export const ActionTypes = {
  LOADING: "GENERATE_AI_PURPOSE_DEFINITION_LOADING",
  ERROR: "GENERATE_AI_PURPOSE_DEFINITION_ERROR",
  SUCCESS: "GENERATE_AI_PURPOSE_DEFINITION_SUCCESS",
};
